import React, { useState, useEffect, useRef } from "react";
import Badmintonguy from "../assets/Badmintonguy.png";
import KosmosBg from "../assets/KosmosBg.jpg";
import { getAnnouncebyTag } from "../Services/BackendUrl";
import axios from "axios";
import "../Homepage/CarouselSection/CarouselSection.scss";
import Marquee from "react-fast-marquee";

export const Kosmos = () => {
  const [announcementMessage, setAnnouncementMessage] = useState([]);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;

    const getAnnouncement = async () => {
      try {
        const response = await axios.get(getAnnouncebyTag, {
          params: { tag: "Branches" },
        });
        setAnnouncementMessage(response.data.announcements);
      } catch (error) {
        console.error("Error fetching announcement:", error);
      }
    };

    getAnnouncement();
  }, []);

  return (
    <div className="relative flex justify-center overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `url(${KosmosBg})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      />
      <div
        className="absolute inset-0 z-10"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      />

      <div className="absolute flex flex-col justify-center text-white top-24 md:top-32 lg:top-48 xl:top-60 px-3 md:px-0">
        <div className="z-30">
          <p className="font-league font-light tracking-widest md:tracking-[7px] xl:tracking-[10px] text-[9px] md:text-[14px] lg:text-[20px] xl:text-[40px]">
            Built for Badminton <span className="text-[#F58220]">.</span>
          </p>
        </div>
        <div className="flex justify-center">
          <div className="z-30">
            <p className="font-langit text-[50px] md:text-[120px] lg:text-[175px] xl:text-[300px]">
              KO
            </p>
          </div>
          <div className="z-10">
            <p className="font-langit text-[50px] md:text-[120px] lg:text-[175px] xl:text-[300px]">
              SMOS
            </p>
          </div>
        </div>
        <div className="grid grid-cols-2">
          <div className="z-30 flex flex-col gap-4 lg:gap-8">
            <p className="text-[8px] md:text-[14px] lg:text-[18px] xl:text-[24px] font-articulat">
              Reserve Your Badminton Court Instantly and Get <br /> Ready to
              Play Without the Wait！
            </p>
          </div>
          <div className="flex">
            <div className="z-30">
              <p className="font-langit text-[25px] md:text-[50px] lg:text-[75px] xl:text-[120px]">
                ACAD
              </p>
            </div>
            <div className="z-20">
              <p className="font-langit text-[25px] md:text-[50px] lg:text-[75px] xl:text-[120px]">
                EMY
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        style={{
          position: "absolute",
          top: "50%",
          left: 0,
          width: "100%",
          height: "50%",
          background: "linear-gradient(to bottom, transparent, black)",
          opacity: 1,
          pointerEvents: "none",
          zIndex: 40,
        }}
      />

      <div className="z-20 relative mt-14 md:mt-0 lg:right-14 xl:right-10">
        <img
          src={Badmintonguy}
          alt="guy"
          className="h-[250px] md:h-[500px] lg:h-[700px] xl:h-[1100px] object-contain max-w-none"
        />
      </div>

      {announcementMessage.length > 0 && (
              <Marquee
              style={{
                position: "absolute",
                bottom: "0px",
                background: "#f58220",
                zIndex: 50,
                width: "100%",
                overflow: "hidden",
                display: "flex",
                padding:'10px',
                height:'50px'
              }}
              gradient={false}
              speed={80}
              pauseOnHover={true}
            >
              {announcementMessage
                .filter((announce) => announce.status === "active")
                .map((announce, index) => (
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      fontFamily: "League Gothic",
                      fontSize: "2rem",
                      color: "white",
                      marginLeft:'20px'
                    }}
                  >
                    {announce.message}
                  </span>
                ))}
            </Marquee>
      ) 
      }
    </div>
  );
};
